import { Component, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { EntertainmentTimesService } from 'src/app/Services/entertainment-times.service';
import { EntertainmentDialogComponent } from '../entertainment-dialog/entertainment-dialog.component';

import * as moment from 'moment';
import { Time } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type EntertainmentTimes = {
  aiiActivityDesc: string;
  aiiActivityName: string;
  aiibegtime: Time;
  aiiendtime: Time;
  aiiDate: Date;
  aiiLocationName: string;
  aiiDisplayLocationName: string;
  slnName: string;
  dplDeck: string;
  dpluid: Int16Array;
  entName: string;
  entImage: string;
  entBioText: string;
};

@Component({
  selector: 'app-entertainment-times',
  templateUrl: './entertainment-times.component.html',
  styleUrls: ['./entertainment-times.component.css'],
  providers: [EntertainmentTimesService],
  encapsulation: ViewEncapsulation.None,
})
export class EntertainmentTimesComponent {
  userdata?: UserData;
  evtCode: string | undefined;
  OBPortalSvcURL = '';

  EntertainmenttimesInfo: EntertainmentTimes[] | undefined;
  entertainmenttimedata: any;
  asofdate: string | undefined;

  constructor(
    private appConfigService: AppConfigService,
    public dialog: MatDialog,
    private EntertainmentTimesService: EntertainmentTimesService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.asofdate = moment().format('YYYY-MM-DD');

    this.getEntertainmentTimes();
  }

  getEntertainmentTimes() {
    this.entertainmenttimedata =
      this.EntertainmentTimesService.getEntertainmentTimes(
        this.evtCode,
        this.asofdate
      ).subscribe((entertainmenttimedata) =>
        this.setEntertainmentTimes(entertainmenttimedata)
      );
  }

  setEntertainmentTimes(resdata: any) {
    this.entertainmenttimedata = resdata;
    if (this.entertainmenttimedata.GetEntertainmentTimes.Result.Status == 'A') {
      this.EntertainmenttimesInfo =
        this.entertainmenttimedata.GetEntertainmentTimes.EntertainmentTimeList;
    }
  }

  showbio(entertainmentitem: EntertainmentTimes) {
    //alert(entertainmentitem.aiiActivityDesc);
    const dialogRef = this.dialog.open(EntertainmentDialogComponent, {
      panelClass: 'entertainerdialog',
      data: {
        entertainmentitem,
      },
    });
  }
}
